import { baseApi } from '@/lib/store/api/baseQuery'
import { apiEndpoints } from '@/lib/api/endpoints'

export interface EmailValidationResponse {
    isValid: boolean
}

export interface EmailValidationRequest {
    email: string
}

export const emailValidationApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        validateEmail: builder.mutation<EmailValidationResponse, EmailValidationRequest>({
            query: ({ email }) => ({
                url: apiEndpoints.emailValidation.validate,
                method: 'POST',
                body: { email },
            }),
        }),
    }),
    overrideExisting: false,
})

export const { useValidateEmailMutation } = emailValidationApi